import { instanceConexao } from "services/axiosServices";
import { AxiosRequestConfig } from "axios";

/**
 * Função para listar responsáveis da revenda.
 *
 * @param {params} params - Parâmetros para listagem.
 * @param {string} params.authToken - Token de autenticação do usuário.
 * @param {string} params.tipoRelatorio - Tipo de relatório, "R", "V", "U" ou "G".
 * @param {string} params.idEmpreendimento - ID do empreendimento.
 * @returns {Promise<any>} - Resposta da API.
 */
export const postListarEquipesRevenda = async (params: {
  authToken: string;
  tipoRelatorio: string;
  idEmpreendimento: string;
}): Promise<any> => {
  const url = "/api/autonomo/ListarAutonomoEquipesRevenda";
  const { authToken, ...parameters } = params;
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
  const response = await instanceConexao.post(url, parameters, config);
  return response?.data;
};
